import React, { useEffect, useState } from "react";
import "./getQuery.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import SuccessModalDynamic from "../SuccessModalDynamic/SuccessModalDynamic";
import ErrorModalDynamic from "../ErrorModalDynamic/ErrorModal";
import { ComlaintQuery, GetComlaintQuery } from "../../../utils/apis/Complaint";

const GetQuery = (props) => {
  const [error, setErrors] = useState("");
  const [data, setData] = useState("");


  const [errorModal, setErrorModal] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await GetComlaintQuery(props?.order_id); // Await the response
        if (res?.success) {
          setData(res?.data);
          // reset(setData);
        } else {
          setErrors(res?.message || "Something went wrong!");
          setData("");
          setErrorModal(true); // Show error modal in case of failure
        }
      } catch (err) {
        console.error("Error fetching data:", err);
        setErrors("Failed to fetch query data");
        setErrorModal(true);
      }
    };

    if (props?.order_id) {
      fetchData(); // Trigger fetch if order_id is provided
    }
  }, [props?.order_id]);

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="CallSupportModal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Get Query Details
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {data && data.length > 0 ? (
            <div className="multi_list_holder">
              {data.map((value, index) => (
                <div className="status_section_holder" key={index}>
                  <div>
                    <div className="query_holder_list">
                      <div className="query_text_holder">
                        <div className="row">
                          <div className="col-md-6">
                            <h6>
                              <b>Ticket Number:</b>
                            </h6>
                          </div>
                          <div className="col-md-6">
                            <p>{value.ticket_no || "No query text"}</p>
                          </div>
                        </div>
                      </div>
                      <div className="query_text_holder">
                        <div className="row">
                          <div className="col-md-6">
                            <h6>
                              <b>Name:</b>
                            </h6>
                          </div>
                          <div className="col-md-6">
                            <p>{value.name || "No status"}</p>
                          </div>
                        </div>
                      </div>{" "}
                      <div className="query_text_holder">
                        <div className="row">
                          <div className="col-md-6">
                            <h6>
                              <b>Email:</b>
                            </h6>
                          </div>
                          <div className="col-md-6">
                            <p>{value.email || "No status"}</p>
                          </div>
                        </div>
                      </div>{" "}
                      <div className="query_text_holder">
                        <div className="row">
                          <div className="col-md-6">
                            <h6>
                              <b>Contact:</b>
                            </h6>
                          </div>
                          <div className="col-md-6">
                            <p>{value.contact_no || "No status"}</p>
                          </div>
                        </div>
                      </div>{" "}
                      <div className="query_text_holder">
                        <div className="row">
                          <div className="col-md-6">
                            <h6>
                              <b>Query:</b>
                            </h6>
                          </div>
                          <div className="col-md-6">
                            <p>{value.query || "No status"}</p>
                          </div>
                        </div>
                      </div>{" "}
                      <div className="query_text_holder">
                        <div className="row">
                          <div className="col-md-6">
                            <h6>
                              <b>Query Date:</b>
                            </h6>
                          </div>
                          <div className="col-md-6">
                            <p>
                              {" "}
                              {value.createdAt
                                ? new Date(value.createdAt).toLocaleString(
                                    "en-US",
                                    {
                                      year: "numeric",
                                      month: "short",
                                      day: "numeric",
                                      hour: "numeric",
                                      minute: "2-digit",
                                      second: "2-digit",
                                      hour12: true,
                                    }
                                  )
                                : "No status"}
                            </p>
                          </div>
                        </div>
                      </div>{" "}
                      <div className="query_text_holder">
                        <div className="row">
                          <div className="col-md-6">
                            <h6>
                              <b>Status:</b>
                            </h6>
                          </div>
                          <div className="col-md-6">
                            <p>
                              {value.complaint_ticket_status?.name ||
                                "No status"}
                            </p>
                          </div>
                        </div>
                      </div>{" "}
                      <div className="query_text_holder">
                        <div className="row">
                          <div className="col-md-6">
                            <h6>
                              <b>Boomerbuckz Remark:</b>
                            </h6>
                          </div>
                          <div className="col-md-6">
                            <p>{value.remark || "No Remark"}</p>
                          </div>
                        </div>
                      </div>{" "}
                      <div className="query_text_holder">
                        <div className="row">
                          <div className="col-md-6">
                            <h6>
                              <b>Status Update Date:</b>
                            </h6>
                          </div>
                          <div className="col-md-6">
                            <p>
                              {value.updatedAt
                                ? new Date(value.updatedAt).toLocaleString(
                                    "en-US",
                                    {
                                      year: "numeric",
                                      month: "short",
                                      day: "numeric",
                                      hour: "numeric",
                                      minute: "2-digit",
                                      second: "2-digit",
                                      hour12: true,
                                    }
                                  )
                                : "No status"}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="query_text_holder">
                        <div className="row">
                          <div className="col-md-6">
                            <h6>
                              <b>Order Invoice No:</b>
                            </h6>
                          </div>
                          <div className="col-md-6">
                            <p>
                              {value.orders_detail?.invoice_no || "No status"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-center text-muted">No Query found.</p>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GetQuery;
